import { BASE_URL, PINNED_STORAGE_KEY, RESULTS_PAGE } from '../../constants';

import type { IProps } from './types';

function getGroupShareLink(group: IProps['group'], item?: IProps['item']): string {
  const shareLink = new URL(RESULTS_PAGE, BASE_URL);

  if (!group) {
    throw new Error('Group is required');
  }

  shareLink.searchParams.set('download_group', String(group));

  if (item) {
    shareLink.searchParams.set('download_item', String(item));
  }

  return shareLink.toString();
}

function getBookmarksShareLink(): string {
  let shareLink = new URL(window.location.href.split('?')[0]);
  // eslint-disable-next-line no-case-declarations
  const storageValue = window.localStorage.getItem(PINNED_STORAGE_KEY);

  try {
    if (storageValue) {
      let shareIds = JSON.parse(storageValue) || [];

      shareIds = shareIds.map(({ group, id }: { group: number; id: number }) => {
        return `${group}:${id}`;
      });
      shareLink = new URL(`${shareLink}?bookmarks=${shareIds.join(',')}`);
    }
  } catch (e) {
    console.error((e as Error).message);
  }

  return shareLink.toString();
}

export function getShareLink(
  type: IProps['type'],
  group?: IProps['group'],
  item?: IProps['item'],
): string {
  if (type === 'group' || type === 'item') {
    return getGroupShareLink(group, item);
  } else if (type === 'bookmarks') {
    return getBookmarksShareLink();
  } else if (type === 'overview') {
    return new URL(window.location.href).toString();
  }

  throw new Error(`Unknown share type: ${type}`);
}
